import React,{FC} from 'react';

const  UnderDev:FC=()=>{
    return(
        <div className="flex flex-col items-center justify-center h-[60vh]">
            <h2 className="text-[24px] font-bold mb-1 text-[#000000]">
                This page is under development
             </h2>
      </div>
    )
}

export default UnderDev;